// eslint-disable-next-line import/prefer-default-export
export const LABEL = Intl.DateTimeFormat().resolvedOptions().timeZone;
